import { SvgChiefDoctor } from '@/components/icons';
import type { CardsListAboutClinicProps } from './../CardsListAboutClinic.types';
import s from './chiefDoctorCard.module.scss';

export const ChiefDoctorCard = ({ aboutData }: CardsListAboutClinicProps) => {
  return (
    <div className={s.card}>
      <div>
        <SvgChiefDoctor />
        <h3 className={s.cardTitleSurname}>{aboutData.chief_doctor_name}</h3>
        <div className={s.card__inner}>
          <p className={s.cardText}>{aboutData.chief_doctor_position}</p>
          <p className={s.cardSubtitle}>Время приема</p>
          <div className={s.cardSchedule} dangerouslySetInnerHTML={{ __html: aboutData.chief_doctor_schedule || '' }} />
        </div>
      </div>
    </div>
  );
};